module.exports = __webpack_public_path__ + "media/images/country_flags/cc-008557c2ee82bdd26975cff4851506dc.png";